import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import Layout from 'components/layout';
import Table from 'components/table';
import Time from 'components/time';
import { Pagination } from 'components';
import { qrDiagnosticsActions } from 'app/actions';
import { PER_PAGE } from 'app/constants';
import { ASC, DESC, QR_DIAG_SORT_FIELD, CLOSED, OPEN } from 'app/constants';

import { DetailedPage } from './components';
import React from 'react';

const HEADERS = [
  [20, 'date', (a, b) => a.registered_on_backend - b.registered_on_backend],
  [20, 'printer', (a, b) => a.printer_model.localeCompare(b.printer_model)],
  [20, 'email', (a, b) => a.user_email.localeCompare(b.user_email)],
  [
    35,
    'user_comment',
    (a, b) => a.comment_on_device.localeCompare(b.comment_on_device),
  ],
];

class PageHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  handleToggleList = () => {
    this.props.updateConfig({ page: 1, status: CLOSED, isTrashOpen: true });
    this.props.getQrDiagnosticsDataThunk();
  };

  handleBackClick = () => {
    this.props.updateConfig({ page: 1, status: OPEN, isTrashOpen: false });
    this.props.getQrDiagnosticsDataThunk();
  };

  render() {
    const { isTrashOpen } = this.props;
    return (
      <div className="page-title justify-content-between">
        <div style={{ display: 'grid', gridTemplateColumns: 'max-content max-content', alignItems: 'center', gap: '5px' }}>
          {isTrashOpen && <a className='page-title_back align-self-center' href="#" onClick={this.handleBackClick} />}
          <h3 style={{ margin: 0 }}>
            {isTrashOpen ? <span><Translate value="attrs.closed" /> </span> : null}
            <Translate value="qr_diagnostics.title" />
          </h3>
        </div>

        <button style={{ visibility: isTrashOpen ? 'hidden' : 'visible', height: 50 }} className="btn btn-primary" onClick={this.handleToggleList}>
          <Translate value="attrs.view_closed" />
        </button>
      </div>
    );
  }
}

const PageHeaderContainer = connect((state) => ({ isTrashOpen: state.qrDiagnostics.config.isTrashOpen }), { updateConfig: qrDiagnosticsActions.updateConfig, getQrDiagnosticsDataThunk: qrDiagnosticsActions.getQrDiagnosticsDataThunk })(PageHeader);

class QRDiagnostics extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getQrDiagnosticsDataThunk();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.props.getQrDiagnosticsDataThunk();
    }
  }

  componentWillUnmount() {
    this.props.resetToDefault();
  }

  renderHeaderRow = () => {
    const {
      config: { sort_field, sort_order },
    } = this.props;

    return (
      <tr>
        <th
          width="20%"
          onClick={this.handleSortChange.bind(
            null,
            QR_DIAG_SORT_FIELD.REGISTERED_AT
          )}
        >
          <a href="#">
            <Translate value="attrs.date" />
            <span
              className={`fa fa-${
                sort_field === QR_DIAG_SORT_FIELD.REGISTERED_AT
                  ? sort_order === ASC
                    ? 'sort-up'
                    : 'sort-down'
                  : 'sort'
              } ml-1`}
            />
          </a>
        </th>
        <th
          width="20%"
          onClick={this.handleSortChange.bind(
            null,
            QR_DIAG_SORT_FIELD.PRINTER_MODEL
          )}
        >
          <a href="#">
            <Translate value="attrs.printer" />
            <span
              className={`fa fa-${
                sort_field === QR_DIAG_SORT_FIELD.PRINTER_MODEL
                  ? sort_order === ASC
                    ? 'sort-up'
                    : 'sort-down'
                  : 'sort'
              } ml-1`}
            />
          </a>
        </th>
        <th
          width="20%"
          onClick={this.handleSortChange.bind(
            null,
            QR_DIAG_SORT_FIELD.USER_EMAIL
          )}
        >
          <a href="#">
            <Translate value="attrs.email" />
            <span
              className={`fa fa-${
                sort_field === QR_DIAG_SORT_FIELD.USER_EMAIL
                  ? sort_order === ASC
                    ? 'sort-up'
                    : 'sort-down'
                  : 'sort'
              } ml-1`}
            />
          </a>
        </th>
        <th width="35%">
          <a href="#">
            <Translate value="attrs.user_comment" />
          </a>
        </th>
        <th width="5%"></th>
      </tr>
    );
  };

  renderRow = (item) => {
    const { history } = this.props;
    return (
      <tr
        key={item.id}
        className="table_row table_row--link"
        onClick={() => history.push(`/qr-diagnostics/${item.id}`)}
      >
        <td>
          <Time value={item.registered_on_backend} />
        </td>
        <td>{item.printer_model}</td>
        <td>{item.user_email}</td>
        <td>
          <div
            style={{ wordBreak: 'break-word' }}
            className="d-flex flex-column text-break"
          >
            {item.comment_on_device && (
              <span>
                <strong><Translate className="colon" value="attrs.from_device" /></strong> {item.comment_on_device}
              </span>
            )}
            {item.comment_on_backend && (
              <span>
                <strong><Translate className="colon" value="attrs.from_backend" /></strong> {item.comment_on_backend}
              </span>
            )}
          </div>
        </td>
        <td className="table_row_actions">
          <span className="fa fa-angle-right" />
        </td>
      </tr>
    );
  };

  handlePageChange = (page) => {
    const { setQrDiagnosticsOffest, getQrDiagnosticsDataThunk } = this.props;
    setQrDiagnosticsOffest(page);
    getQrDiagnosticsDataThunk();
  };

  handleSortChange = (sortField) => {
    this.props.changeSortFieldThunk(sortField);
  };

  render() {
    const { history, list, match, config } = this.props;
    const { total, page } = config;

    return (
      <Layout>
        {match.params.id ? (
          <DetailedPage history={history} id={match.params.id} />
        ) : (
          <Table
            headers={HEADERS}
            renderHeaderRow={this.renderHeaderRow}
            renderRow={this.renderRow}
            list={list}
            title="qr_diagnostics.title"
            onDelete={() => {}}
            sortingBack
            hideActionButtons
            pageHeader={<PageHeaderContainer />}
          >
            {PER_PAGE < total && (
              <Pagination
                page={page}
                totalItemsCount={total}
                onPageChange={this.handlePageChange}
              />
            )}
          </Table>
        )}
      </Layout>
    );
  }
}

const mapStateToProps = ({ qrDiagnostics }) => {
  return {
    list: qrDiagnostics.list,
    config: qrDiagnostics.config,
  };
};

export default connect(mapStateToProps, { ...qrDiagnosticsActions })(
  QRDiagnostics
);
